import React, { useEffect, useRef, useState } from 'react'
import Sidebar from '../../components/Structure/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { FxRateAPI } from '../../@redux/Action/FX_Rate_Action';
import { useNavigate } from 'react-router-dom';
import { checkSession } from '../../@redux/Action/Config';


function Dashboard({studentId}) {
    useEffect(() => {
        dispatch(checkSession());
    }, []);
    const fxRateValue = useSelector((state) => state.fxRate?.fxRateRes)
    console.log("fxRateValue is ", fxRateValue)
    const [fxRateQuery, setFxRateQuery] = useState({
        'destination_currency': '',
        'destination_amount': ''
    });
    //for error negative amount
    const [amountError, setAmountError] = useState('');
    const dispatch = useDispatch();
    const debounceTimer = useRef(null);

    const debounce = (func, delay) => {
        clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(func, delay)
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        //for error negative amount
        if (name === 'destination_amount') {
            if (Number(value) < 0) {
                setAmountError('Please enter a positive amount');
                return;
            }
            setAmountError('');
        }

        setFxRateQuery(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (name === 'destination_amount' && Number(value) >= 0)
            debounce(() => {
                dispatch(FxRateAPI({
                    ...fxRateQuery,
                    [name]: value
                }));
            }, 1000)
    };

    const Navigate = useNavigate();

    const handleProceed = (e) => {
        e.preventDefault();
        Navigate(`/onboarding`);
    }

    const formatNumber = (value) => {
        if (value === undefined || value === null) {
            return '';
        }
        return Number(value).toFixed(2);
    }
    return (
        <div className='' >
            <div className='d-md-flex ' style={{ height: '100vh' }}>
                {/* left section */}
                <Sidebar />
                {/* right section */}
                <div className='col-12 col-md-9 px-4 d-flex flex-column overflow-auto linear-background-color' >
                    {/* First fx rate */}
                    <div className="d-none card bg-transparent border-0 px-2 pt-3 w-50 mx-auto my-auto ">
                        <div className="card-body">
                            <form
                            //  onSubmit={handleProceed}
                            >
                                <div className='mb-3'>
                                    <h4 className='text-center text-success fw-bold'>Check Exchange Amount</h4>
                                </div>
                                <div className="d-flex gap-2 mb-5">
                                    <select
                                        id="destination_currency"
                                        className="form-select border-0 shadow-sm "
                                        name="destination_currency"
                                        style={{
                                            borderRadius: "8px",
                                            backgroundColor: "#f8f9fa",
                                            color: "#343a40",

                                        }}
                                        // onChange={handleOnChange}
                                        // value={fxRateQuery?.destination_currency}
                                        required
                                    >
                                        <option value="">Choose currency</option>
                                        <option value="USD">USD - US Dollar</option>
                                        <option value="AUD">AUD - Australian Dollar</option>
                                        <option value="SGD">SGD - Singapore Dollar</option>
                                        <option value="CAD">CAD - Canadian Dollar</option>
                                        <option value="GBP">GBP - British Pound</option>
                                        <option value="EURO">EURO - Euro</option>
                                    </select>

                                    <input
                                        id="destination_amount"
                                        type="number"
                                        className="form-control border-0 shadow-sm"
                                        name="destination_amount"
                                        placeholder="Enter amount"
                                        style={{
                                            borderRadius: "8px",
                                            backgroundColor: "#f8f9fa",
                                            color: "#343a40",
                                        }}
                                        // value={fxRateQuery?.destination_amount}
                                        // onChange={handleOnChange}
                                        // disabled={!fxRateQuery?.destination_currency}
                                        required
                                    />
                                </div>
                                <div className="my-5" >
                                    <div className="p-3 rounded-3 bg-white shadow-sm">
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-flex justify-content-between">
                                                <span className='text-success fw-bold'>
                                                    Exchange Rate:
                                                </span>
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#28a745" }}
                                                >
                                                    {/* {formatNumber(fxRateValue?.fx_rate)} */}
                                                </span>
                                            </li>
                                            <li className="d-flex justify-content-between mt-2">
                                                <span className='text-success fw-bold'>Fees:</span>
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#28a745" }}
                                                >
                                                    {/* {formatNumber(fxRateValue?.fees)} */}
                                                </span>
                                            </li>
                                            <li className="d-flex justify-content-between mt-2">
                                                <span className='text-success fw-bold'>TCS Rate:</span>
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#28a745" }}
                                                >
                                                    {/* {formatNumber(fxRateValue?.tcs)} */}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="my-5">

                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control border-0 shadow-sm me-2"
                                            value="INR"
                                            disabled
                                            style={{
                                                borderRadius: "8px",
                                                backgroundColor: "#f8f9fa",
                                                color: "#343a40",
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control border-0 shadow-sm"
                                            placeholder="Equivalent amount"
                                            style={{
                                                borderRadius: "8px",
                                                backgroundColor: "#f8f9fa",
                                                color: "#343a40",
                                            }}
                                        // value={formatNumber(fxRateValue?.final_amount)}
                                        />
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-success px-4 py-2"
                                        style={{
                                            borderRadius: "12px",
                                            backgroundColor: "#28a745",
                                            border: "none",
                                            color: "#fff",
                                        }}
                                    >
                                        Proceed
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Second fx rate */}
                    <div className='bg-white  mx-2 px-3 py-3 col-6 rounded-4 mx-auto my-auto'>
                        <form onSubmit={handleProceed}>
                            <div>
                                <h3 className='text-success fw-bold text-center'>Check exchange rate</h3>

                            </div>
                            <div className='my-4'>
                                <p className='text-success'>Fees to pay</p>
                                <div className='d-flex justify-content-center gap-5'>
                                    <div className='col-5'>
                                        <select className='form-select text-success w-100 shadow-none' name='destination_currency'
                                            value={fxRateQuery?.destination_currency} onChange={handleOnChange}
                                            required>
                                            <option value=''>Choose currency</option>
                                            <option value="USD">USD</option>
                                            <option value="AUD">AUD</option>
                                            <option value="SGD">SGD</option>
                                            <option value="CAD">CAD</option>
                                            <option value="GBP">GBP</option>
                                            <option value="EURO">EURO</option>
                                        </select>
                                    </div>

                                    <div className='col-5'>
                                        <input type='number' className='form-control w-100 shadow-none text-success' name='destination_amount' placeholder='Enter Amount'
                                            value={fxRateQuery?.destination_amount}
                                            onChange={handleOnChange}
                                            disabled={!fxRateQuery?.destination_currency}
                                            required />
                                        {/* for error negative amount */}
                                        {amountError && <div className="text-danger mt-1">{amountError}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='my-4'>
                                <div className='mb-3 text-success'><span style={{ textDecoration: 'underline' }}>Applied Charges</span></div>
                                <div className='d-flex justify-content-center gap-5 text-secondary ' style={{ fontSize: '0.95rem', }}>
                                    <div className='col-5'>
                                        <div>
                                            <ul className='list-unstyled text-success fw-bold'>
                                                <li>Fx_rate</li>
                                                <li>Fees</li>
                                                <li>TCS_Rate</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-5 text-start'>
                                        <span className='d-none' style={{ textDecoration: 'underline' }}>0 INR</span>
                                        <div className='text-start'>
                                            <ul className='list-unstyled text-end text-success fw-bold'>
                                                {/* <li>{formatNumber(fxRateValue?.fx_rate)}</li> */}
                                                <li>{formatNumber(fxRateValue?.fx) || '0.00'}</li>
                                                <li>{formatNumber(fxRateValue?.fees) || '0.00'}</li>
                                                <li>{formatNumber(fxRateValue?.tcs) || '0.00'}</li>
                                            </ul>   
                                        </div></div>
                                </div>
                            </div>

                            <div className='my-4'>
                                <p className='text-success'>Exchange in your currency</p>

                                <div className='d-flex justify-content-center gap-5'>
                                    <div className='col-5'>
                                        <input type='text' className='form-control text-success shadow-none  w-100' value='INR' disabled />
                                    </div>

                                    <div className='col-5'>
                                        <input type='text' className='form-control  shadow-none w-100 text-success'
                                            placeholder='Total Amount'
                                            value={formatNumber(fxRateValue?.finalAmount)}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='text-end mt-3'>
                                <button className=' btn btn-success  px-3 py-2 rounded-3 border-1'> Proceed </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Dashboard